export default "https://assets.egbcdn.net/assets/packs/_/images/app/android/android-en-3-23fa1c313b4526a661b192386c8f2300.png";